import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 子组织列表
export const setSubOrgs: Mutation<IModuleState> = (state, payload) => {
  state.subOrgs.data = payload.data;
  state.subOrgs.total = payload.total;
  state.subOrgs.pageNum = payload.pageNum;
  state.subOrgs.pageSize = payload.pageSize;
  state.subOrgs.loading = !!payload.loading;
};

// 子组织待授权的品牌列表
export const setUnAuthedBrands: Mutation<IModuleState> = (state, payload) => {
  state.unAuthedBrands.data = payload.data;
  state.unAuthedBrands.total = payload.total;
  state.unAuthedBrands.pageNum = payload.pageNum;
  state.unAuthedBrands.pageSize = payload.pageSize;
  state.unAuthedBrands.loading = !!payload.loading;
};

// 子组织已授权的品牌列表
export const setAuthedBrands: Mutation<IModuleState> = (state, payload) => {
  state.authedBrands.data = payload.data;
  state.authedBrands.total = payload.total;
  state.authedBrands.pageNum = payload.pageNum;
  state.authedBrands.pageSize = payload.pageSize;
  state.authedBrands.loading = !!payload.loading;
};

// 父组织详情
export const setParentOrgDetail: Mutation<IModuleState> = (state, payload) => {
  state.parentOrgDetail.data = payload.data;
  state.parentOrgDetail.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
